/* =========================================================
   MATCH DAY – scripts du thème
   ========================================================= */
(function () {
  'use strict';

  var theme = window.theme || {};
  var strings = theme.strings || {};
  var routes = theme.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  /* ---------- Utilitaires ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '{{amount}} €';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function delim(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(re);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = delim(cents, 0); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = delim(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delim(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      default: value = delim(cents, 2);
    }
    return format.replace(re, value);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(text, showLink) {
    var el = $('[data-toast]');
    if (!el) return;
    $('[data-toast-text]', el).textContent = text;
    var link = $('.toast__link', el);
    if (link) link.hidden = !showLink;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 350);
    }, 3600);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  }

  /* ---------- Header au défilement ---------- */
  function initHeaderScroll() {
    var onScroll = function () {
      var header = $('[data-header]');
      if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Menu déroulant ---------- */
  var lastFocus = null;
  function getDrawer() { return $('[data-drawer]'); }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer || drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('has-drawer');
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var close = $('.menu-drawer__close', drawer);
    if (close) setTimeout(function () { close.focus({ preventScroll: true }); }, 60);
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('has-drawer');
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    $$('details[open]', drawer).forEach(function (d) { d.removeAttribute('open'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    var drawerLink = e.target.closest('.menu-drawer__link');
    if (drawerLink && drawerLink.getAttribute('href') && drawerLink.getAttribute('href').charAt(0) === '#') closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
    if (e.key === 'Tab') {
      var drawer = getDrawer();
      if (!drawer || !drawer.classList.contains('is-open')) return;
      var focusables = $$('a[href], button:not([disabled]), summary, input', $('.menu-drawer__panel', drawer))
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Sélecteurs de quantité ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var min = input.min !== '' ? parseInt(input.min, 10) : 0;
    var max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
    var val = parseInt(input.value, 10) || 0;
    val = btn.hasAttribute('data-qty-plus') ? val + 1 : val - 1;
    val = Math.max(min, Math.min(max, val));
    if (String(val) === input.value) return;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Lien retour ---------- */
  document.addEventListener('click', function (e) {
    var back = e.target.closest('[data-back-link]');
    if (!back) return;
    try {
      if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {
        e.preventDefault();
        history.back();
      }
    } catch (err) { /* lien normal */ }
  });

  /* ---------- Copier le lien ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-copy-link');
    if (navigator.share && /Mobi/i.test(navigator.userAgent)) {
      navigator.share({ url: url, title: document.title }).catch(function () {});
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast(strings.linkCopied || 'Lien copié', false); });
    }
  });

  /* ---------- Page produit ---------- */
  function initProduct(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var json = $('[data-product-variants]', root);
    var variants = [];
    try { variants = JSON.parse(json.textContent); } catch (err) { variants = []; }

    var formId = root.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var qtyInput = $('[data-qty-input]', root);
    var priceEl = $('[data-price-current]', root);
    var compareEl = $('[data-price-compare]', root);
    var totalEl = $('[data-total]', root);
    var addBtn = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var errorEl = $('[data-form-error]', root);
    var track = $('[data-gallery-track]', root);

    var current = variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || variants[0];

    function selectedOptions() {
      return $$('[data-option-position]', root)
        .sort(function (a, b) { return a.dataset.optionPosition - b.dataset.optionPosition; })
        .map(function (fs) {
          var checked = $('input:checked', fs);
          return checked ? checked.value : null;
        });
    }

    function qty() { return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1; }

    function render() {
      if (!current) return;
      if (priceEl) priceEl.innerHTML = formatMoney(current.price);
      if (compareEl) {
        compareEl.hidden = !(current.compare > current.price);
        if (current.compare > current.price) compareEl.innerHTML = formatMoney(current.compare);
      }
      if (totalEl) totalEl.innerHTML = formatMoney(current.price * qty());
      if (addBtn) {
        addBtn.disabled = !current.available;
        if (addLabel) addLabel.textContent = current.available ? (addBtn.dataset.label || strings.addToCart) : strings.soldOut;
      }
    }

    function onOptionChange() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
      if (!match) {
        if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = strings.unavailable; }
        return;
      }
      current = match;
      if (idInput) idInput.value = match.id;
      render();
      if (errorEl) errorEl.hidden = true;
      try {
        var url = new URL(location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      } catch (err) { /* noop */ }
      if (match.media && track) {
        var slide = $('[data-media-id="' + match.media + '"]', track);
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) onOptionChange();
      if (e.target.matches('[data-qty-input]')) {
        var max = parseInt(e.target.max, 10) || 99;
        e.target.value = Math.max(1, Math.min(max, parseInt(e.target.value, 10) || 1));
        render();
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        if (errorEl) errorEl.hidden = true;
        var body = new FormData(form);
        if (!body.get('quantity')) body.set('quantity', qty());
        fetch(routes.cartAdd + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (r) {
            if (!r.ok) throw new Error(r.data.description || r.data.message || strings.error);
            return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            toast(strings.added, true);
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message || strings.error; errorEl.hidden = false; }
          })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      });
    }

    render();
  }

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    var thumbs = $$('[data-thumb]', root);
    var prev = $('[data-gallery-prev]', root);
    var next = $('[data-gallery-next]', root);
    function go(dir) { track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var slide = $('[data-media-id="' + t.dataset.thumb + '"]', track);
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Compte à rebours ---------- */
  function initCountdown(el) {
    if (!el || el.dataset.ready) return;
    el.dataset.ready = '1';
    var raw = (el.getAttribute('data-countdown') || '').trim().replace(' ', 'T');
    var target = new Date(raw);
    if (isNaN(target.getTime())) return;
    var cells = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = target.getTime() - Date.now();
      if (diff <= 0) { el.hidden = true; clearInterval(timer); return; }
      el.hidden = false;
      var s = Math.floor(diff / 1000);
      cells.d.textContent = pad(Math.floor(s / 86400));
      cells.h.textContent = pad(Math.floor((s % 86400) / 3600));
      cells.m.textContent = pad(Math.floor((s % 3600) / 60));
      cells.s.textContent = pad(s % 60);
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Panier ---------- */
  function initCart(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var sectionId = root.getAttribute('data-section-id');
    var timer;

    function refresh() {
      return fetch(location.pathname + '?section_id=' + encodeURIComponent(sectionId))
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart]');
          if (fresh) root.innerHTML = fresh.innerHTML;
        });
    }

    function change(line, quantity) {
      root.classList.add('is-loading');
      return fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error(r.data.description || r.data.message || strings.error);
          updateCartCount(r.data.item_count);
          return refresh();
        })
        .catch(function (err) { toast(err.message || strings.error, false); return refresh(); })
        .finally(function () { root.classList.remove('is-loading'); });
    }

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        change(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
      }, 350);
    });

    root.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (!remove) return;
      e.preventDefault();
      var ticket = remove.closest('.ticket');
      if (ticket) { ticket.style.transition = 'opacity .25s, transform .25s'; ticket.style.opacity = '0'; ticket.style.transform = 'translateX(16px)'; }
      change(parseInt(remove.dataset.line, 10), 0);
    });
  }

  /* ---------- Initialisation ---------- */
  function initAll(ctx) {
    $$('[data-product]', ctx).forEach(initProduct);
    $$('[data-gallery]', ctx).forEach(initGallery);
    $$('[data-countdown]', ctx).forEach(initCountdown);
    $$('[data-cart]', ctx).forEach(initCart);
  }

  initHeaderScroll();
  initAll(document);

  /* ---------- Éditeur de thème ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    if (e.target.querySelector('[data-drawer]')) document.documentElement.classList.remove('has-drawer');
  });
  document.addEventListener('shopify:block:select', function (e) {
    if (!e.target.closest('.menu-drawer')) return;
    openDrawer();
    var details = e.target.closest('details');
    if (details) details.setAttribute('open', '');
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    if (e.target.closest('.menu-drawer')) closeDrawer();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-drawer]')) closeDrawer();
  });
})();
